import { gql } from '@apollo/client';
import { apolloClient } from '../apollo/client';

const SOLICITAR_RECUPERACAO_SENHA = gql`
  mutation SolicitarRecuperacaoSenha($email: String!, $resetBaseUrl: String!) {
    solicitarRecuperacaoSenha(email: $email, resetBaseUrl: $resetBaseUrl)
  }
`;

export const solicitarRecuperacaoSenha = async (email: string, resetBaseUrl: string) => {
  const { data } = await apolloClient.mutate({
    mutation: SOLICITAR_RECUPERACAO_SENHA,
    variables: { email, resetBaseUrl },
  });
  return data?.solicitarRecuperacaoSenha;
};

const REDEFINIR_SENHA = gql`
  mutation RedefinirSenha($token: String!, $novaSenha: String!) {
    redefinirSenha(token: $token, novaSenha: $novaSenha)
  }
`;

export const redefinirSenha = async (token: string, novaSenha: string) => {
  const { data } = await apolloClient.mutate({
    mutation: REDEFINIR_SENHA,
    variables: { token, novaSenha },
  });
  return data?.redefinirSenha;
};
